import React from "react";
import Text from "components/text/Text";
import styles from "./DoctorRefinements.module.scss";
import strings from "assets/strings";
import { RefinementListProps } from "components/dropdown/Dropdown";
import { DropdownLocalAlgolia } from "components/dropdownLocalAlgolia/DropdownLocalAlgolia";
import { CustomDropdown } from "components/customDropdown/CustomDropdown";
//import { CustomSearch } from "components/inputs/customSearch/CustomSearch";
import { algoliaAttributes, aroundRadiusOptions } from "assets/constants";
import { DropdownLocalAlgoliaWithSearch } from "components/dropdownLocalAlgoliaWithSearch/DropdownLocalAlgoliaWithSearch";
import { checkIfParamExist, getAllClassNames } from "helpers";
import { CustomCheckboxes } from "components/buttons/customCheckboxes/CustomCheckboxes";
export interface DoctorRefinementsProps {
  isLeumit: boolean;
  objectType: any;
}

const sortByTimeOfDay: RefinementListProps['sortBy'] = (a, b) => {
  const order: Record<string, number> = {
    "morning": 1,
    "noon": 2,
    "evening": 3
  };
  return order[a.name.toLocaleLowerCase()] - order[b.name.toLocaleLowerCase()];
};

const queryString = window.location.search;
const urlSearchParams = new URLSearchParams(queryString);

const transformItems = (items: any[], type: string) => {
  if (type === algoliaAttributes.DoctorType) {
    return items
      .filter((item) => item.label === "1")
      .map((item) => ({
        ...item,
        label: strings.doctorSearchResults.showOnlySurgeons,
      }));
  }
  return items.map((item) => ({
    ...item,
    label:
      type === algoliaAttributes.Gender
        ? item.label === "נ"
          ? strings.globalStrings.female
          : strings.globalStrings.male
        : item.label,
  }));
};

const transformMashlimItems = (items: any[], type: string) => {
  return items.map((item) => ({
    ...item,
    label:
      type === algoliaAttributes.Gender
        ? item.label === "נ"
          ? strings.globalStrings.female
          : strings.globalStrings.male
        : type === algoliaAttributes.ExternalDoctorType
          ? item.label === "1"
            ? strings.doctorSearchResults.showArrangement
            : strings.doctorSearchResults.showRefund
          : item.label,
  }));
};

const transformTimeOfDayItems = (items: any[]) => {
  return items.map((item) => ({
    ...item,
    label:
      item.label === "Morning"
        ? strings.globalStrings.morning
        : item.label === "Noon"
          ? strings.globalStrings.noon
          : item.label === "Evening"
            ? strings.globalStrings.evening
            : item.label,
  }));
};

export const DoctorRefinements = (props: DoctorRefinementsProps) => {
  const { isLeumit, objectType } = props;
  return (
    <div className={`${getAllClassNames([styles.container])} col-12 col-lg-4 col-xl-3`}>
      <aside className={styles.aside}>
        <Text
          className={styles.title}
          text={strings.globalStrings.filterBy}
        />

        {(objectType == 1 && !isLeumit) && <CustomCheckboxes
          title={strings.doctorSearchResults.arrangementRefund}
          info={strings.doctorSearchResults.arrangementRefundInfo}
          attribute={algoliaAttributes.ExternalDoctorType}
          transformItems={(items) =>
            transformMashlimItems(items, algoliaAttributes.ExternalDoctorType)
          }
          sortBy={["name:asc"]}
        />
        }
        {(checkIfParamExist('medicalFieldName') && isLeumit) && <DropdownLocalAlgolia
          hideContinueBtn
          attribute={algoliaAttributes.SubMdicalFieldName}
          title={strings.doctorSearchResults.subMedicalField}
        />
        }
        {/* 
        {!checkIfParamExist('loc') && <DropdownLocalAlgolia
          hideContinueBtn
          multiSelect
          isPopup
          attribute={algoliaAttributes.City}
          title={strings.globalStrings.city}
          titlePopup={strings.globalStrings.chooseCity}
          subTitlePopUp={strings.globalStrings.canChooseCity}    
          sortBy={["name:asc"]}   
        />
        } */}

        {!checkIfParamExist('loc') && <DropdownLocalAlgoliaWithSearch
          attribute={algoliaAttributes.City}
          title={strings.globalStrings.city}
        />
        }

        {checkIfParamExist('loc') && <CustomDropdown
          selectOptions={aroundRadiusOptions}
          title={strings.globalStrings.distance}
          slectedValue={urlSearchParams.has("r") && Number(urlSearchParams.get("r")) !== 10000 ? Number(urlSearchParams.get("r")) : 10000}
          defaultValue={10000}
        />}
        {/* <CustomSearch
          attribute="fullName"
          title={strings.doctorSearchResults.searchByDoctorName}
          marginTop={20}
        /> */}
        <DropdownLocalAlgoliaWithSearch
          attribute="fullName"
          title={strings.doctorSearchResults.searchByDoctorName}
        />
        <CustomCheckboxes
          title={strings.doctorSearchResults.doctorGender}
          attribute={algoliaAttributes.Gender}
          transformItems={(items) => transformItems(items, algoliaAttributes.Gender)}
          sortBy={["name:asc"]}
        />
        {(objectType == 1 && isLeumit) &&
          <CustomCheckboxes
            isSingle
            title={strings.doctorSearchResults.showOnlySurgeons}
            attribute={algoliaAttributes.DoctorType}
            transformItems={(items) =>
              transformItems(items, algoliaAttributes.DoctorType)
            }
          />
        }
        <CustomCheckboxes
          isFlex
          sortBy={["name:asc"]}
          title={strings.globalStrings.visitDays}
          attribute={algoliaAttributes.DaysOfWeek}
          transformItems={(items) => (items)}
        />

        <CustomCheckboxes
          title={strings.globalStrings.visitHours}
          attribute={algoliaAttributes.WorkHours}
          transformItems={(items) => transformTimeOfDayItems(items)}
          sortBy={sortByTimeOfDay}
        />

        <CustomCheckboxes
          title={strings.globalStrings.languages}
          attribute={algoliaAttributes.Languages}
          sortBy={["name:asc"]}
        />
      </aside>
    </div>
  );
};
